import React, { Component } from "react";
import {
  StyleSheet,
  ActivityIndicator,
  ImageBackground,
  StatusBar,
  ScrollView,
  SafeAreaView,
  Text,
  View,
  TouchableOpacity,
  findNodeHandle,
  Image,
  Dimensions
} from "react-native";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HTML from "react-native-render-html";
import { removeUserToken } from "../../../redux/User/user.actions";
import AppFooter from "../../components/app-footer";
import AppHeader from "../../components/app-header";
import AuthenticationWrapper from "../../components/authentication-wrapper";
import ErrorModal from "../../components/error-modal";
import PostShare from "../../components/post-share";
import {
  appStyles,
  Colors,
  Flex,
  button,
  FontFamily,
  postExcerptTags,
  postExcerptClasses,
  postExcerptTagsDarkMode,
  Helpers,

  postSingle,
  Padding,
  Margin,
  Typo,
  actionBox,
  accessContent,
  exclusiveContent,
  textBlock,
  articleLoader,
  articleLists,
  FontWeight,
  article,
  articleItem,
  pageContent,

} from "../../styles/appStyles";
import { helpers } from "../../utils/helpers";
import CustomImage from "../../components/custom-image";
import getImagePath from "../../utils/image-helper";
import ButtonGradient from "../../components/button-gradient";
import { DEVICE_WIDTH } from "../../components/custom-camera";
import ScrollContainerView from "../../components/scroll-container-view";
import DontStopReading from "../../components/dont-stop-reading";
import YesterdayDontStopReading from "../../components/yesterday-dont-stop-reading";
import apiHelpers from "../../utils/api-helpers";
import PostContent from "../../components/post-content";
import moment from "moment";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import Seo from "../../components/seo-meta";
import seoObj from "../../utils/seo-helper";
import {
  renderBorderColor,
  categoryImage,
  paddingCategory,
} from "../../screens/yesterday/renderBorderColor";
import { Popable } from "react-native-popable";

const healthcare = getImagePath("icons/healthcare.png");
const business = getImagePath("icons/business.png");
const covid = getImagePath("icons/covid-19.png");
const envoroment = getImagePath("icons/envoroment.png");
const markets = getImagePath("icons/markets.png");
const sports = getImagePath("icons/sports.png");
const world = getImagePath("icons/world.png");
const economy = getImagePath("icons/economy.png");
const choas = getImagePath("icons/choas.png");
const politics = getImagePath("icons/politics.png");

const facebook16 = getImagePath("icons/fb.png");
const link16 = getImagePath("icons/link16.png");
const twitter16 = getImagePath("icons/twitterIcon.png");
const linkedin16 = getImagePath("icons/linkedin_icon.png");
const profile = getImagePath("img/priya-profile.jpg");
const storyNameThumbnial = getImagePath("img/storyNameThumbnial.png");
const logo = getImagePath("img/logo.png");
const storyRegister1 = getImagePath("img/storyRegister1.png");
const storyRegister2 = getImagePath("img/storyRegister2.png");
const storyRegister3 = getImagePath("img/storyRegister3.png");
const archiveIStoryName = getImagePath("img/archiveIStoryName.png");

const PrivilegeCreditGift = {
  id: "privilege_credits",
  name: "Gift a story",
  tmc_group: "",
  billing_enitity_type: "adhoc",
  invoice_name: "Gift a story",
  description: {
    access_desc: [
      "Can gift upto 5 privilege credits a month for free",
      "Can be used to unlock any long form story or newsletter of your choice",
    ],
  },
  is_popular: false,
  recommended_plan: false,
  discount: {},
  is_story_gift: true,
};

export class YesterdayStoryScreen extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    const { isAuthenticated, fetchToken } = this.props.auth;
    let token = webView
      ? process.browser
        ? isAuthenticated
          ? fetchToken
          : false
        : this.props.token
      : this.props.user?.userData?.data?.token;

    this.state = {
      pageLoader: false,
      showErrorModal: false,
      showUparrow: false,
      footerData: this.props.footerData ? this.props.footerData : false,
      isUserLoggedIn: token == undefined || token == "" ? false : true,
      locked_content:
        "<p><span class='firstletter'>I</span>f a bad penny were to acquire a name at this point in time, chances are it would settle for calling itself Gautam Singhania. Because Raymond, the iconic company Singhania inherited from his father, and of which he is chairman and managing director, is now perhaps in the most precarious position it has ever been in its 96-year history.</p> <p>Last year, several members of its senior management team, assiduously built over five years, quit. A replacement CEO for the lifestyle business put in his papers last month, after just seven months on the job. To think this happened at a time when the company had posted its biggest ever annual loss has given shareholders cause for concern. To add to their worries, Raymond’s valuation is down to Rs 2,600 crore, lesser than the value of 125 acres of land it holds in Mumbai’s suburbs. (A group company had sold 20 acres for Rs 700 crore in 2019.)</p> <p>Singhania, meanwhile, has been busy adding to his collection of vintage cars, a pursuit he seems</p>",
      isArchiveStory: false,
      token: token,
      storyData:
        this.props.postData?.data || this.props.history.location.state || false,
      seletedTab: 0,
      seeSecondAuthor: false,
      hideSideShareActionButton: true,
      scrollCheck: 0,
    };
    this._nodes = new Map();
  }

  /************* Business Logics start ***************/

  componentDidMount = () => {
    setTimeout(() => {
      // let location = "https://themorningcontext.com/yesterday/natural-gas-prices-to-be-more-than-doubled-axis-bank-to-buy-citis-india-retail-business-and-cci-raids-tyre-manufacturers?post_id=2"
      let location = window.location.href;
      let post_id = location.indexOf("?");
      if (post_id > -1) {
        var url = new URL(location);
        var id = url.searchParams.get("post_id");
        this.setState({ seletedTab: parseInt(id) });
        this.scrollToElement(parseInt(id));
      }
    }, 2000)

    if (!this.state.storyData) this.YesterdayApiData();
  };

  openSocialMedia = (link) => {
    if (helpers.isWeb()) {
      window.open(link, "_blank");
    } else {
      if (link == "/investors") {
        this.props.navigation.navigate("/investors");
      } else {
        // Linking.openURL(link);
        // this.props.navigation.navigate('in-app-browser', { url: link });
        this.refs.header.openLink(link);
      }
    }
  };

  // shareOnLinkedIn = (path, index, title) => {
  //   let body = {
  //     "lifecycleState": "PUBLISHED",
  //     "specificContent": {
  //       "com.linkedin.ugc.ShareContent": {
  //         "shareCommentary": {
  //           "text": title
  //         },
  //         "shareMediaCategory": "ARTICLE",
  //         "media": [
  //           {
  //             "status": "READY",
  //             "description": {
  //               "text": title
  //             },
  //             "originalUrl": path,
  //             "title": {
  //               "text": title
  //             }
  //           }
  //         ]
  //       }
  //     },
  //     "visibility": {
  //       "com.linkedin.ugc.MemberNetworkVisibility": "PUBLIC"
  //     }
  //   }
  //   apiHelpers.linkedInShare(body)
  //     .then((res) => {
  //       console.log('share:', res);
  //     })
  //     .catch((error) => {
  //       console.log("Error=>> down", JSON.stringify(error));
  //     });
  // }

  /**
   * Scroll to top on click of FAB icon
   */
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // auto
    });
  };

  /**
   * Scroll to the specific element
   * @param {Number} indexOf : index number
   */
  scrollToElement = (indexOf) => {
    const node = this._nodes.get(indexOf);
    const position = findNodeHandle(node);
    let ext_offset = helpers.isDesktop() ? 850 : 500;
    window.scroll(0, position.offsetTop + ext_offset); //position.offsetWidth - 850 for desktop
  };

  /**
   * On click of link, copy to clipboard
   */
  copyToClipboard = () => {
    let path = window.location.origin + window.location.pathname;
    navigator.clipboard.writeText(path);
  };

  YesterdayApiData = () => {
    const { token } = this.state;
    let endpoint = `/yesterday/editions/${this.props.postSlug}`;
    let body = {
      // "limit": 1,
      sort_on: "published_date",
      sort_by: "DESC",
      // "start_date": "13-11-2021",
      // "end_date": "13-11-2021",
      // "published_date": "14-11-2021",
      published_date: moment(new Date()).format("DD-MM-YYYY"),
      // paged: 1,
    };
    apiHelpers
      .apiRequest(endpoint, body, "GET", true, token)
      .then((res) => {
        this.setState({
          storyData: res.data,
        }, () => {
          console.log('storyData:', this.state.storyData);
        });
      })
      .catch((error) => {
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  /**
   * Navigate to the Yesterday Landing page
   */
  navigateScreen = (action) => {
    action === "button"
      ? this.props.navigateToScreen(`/yesterday`, {
        fromModule: "story-screen",
      })
      : this.props.navigateToScreen(`/yesterday`);
  };

  applyRef = (ref) => {
    if (helpers.isWeb()) {
      this.scrollRef = window.addEventListener("scroll", this.getScrollOffset);
    }
  };

  sharePost = (slug) => {
    let { isUserLoggedIn, isArchiveStory, storyData, seletedTab } = this.state;
    if (helpers.isWeb()) {
      let path = window.location.origin + window.location.pathname;
      // let path = "https://themorningcontext.com" + window.location.pathname;

      if (slug == "fb") {
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${path}&quote=${ReactHtmlParser(
            storyData.title
          )}`,
          "_blank"
        );
      } else if (slug == "twitter") {
        window.open(
          `https://twitter.com/intent/tweet?text=${ReactHtmlParser(
            storyData.title
          )}&url=${path}`,

          "_blank"
        );
      } else if (slug == "linkedin") {
        window.open(
          `https://www.linkedin.com/shareArticle?mini=true&url=${path}&summary=${ReactHtmlParser(
            storyData.title
          )}`,
          "_blank"
        );
      } else {
        navigator
          .share({
            title: storyData.title,
            text: storyData.title,
            url: path,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    } else {

      Share.share({
        message: `${helpers.siteURL}/${postData.category.slug}/${postData.story.slug}`,
      });
    }
  };

  getScrollOffset = (event) => {
    let hideSideShareActionButton;
    console.log('hideSideShareActionButton')
    if (
      window.scrollY <= 500
    ) {
      hideSideShareActionButton = true;
    } else {
      hideSideShareActionButton = false;
    }

    this.setState({
      hideSideShareActionButton: hideSideShareActionButton,
    });
  };

  /***************** Business logic End & View Render start **************/

  renderPageHeader = () => {
    return <></>;
  };

  showPageLoader = () => {
    const webView = helpers.isWeb();
    return (
      <View
        style={[
          Flex.justfiyCenter,
          Flex.alignCenter,
          {
            position: webView ? "fixed" : "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: "#ffffff",
          },
        ]}
      >
        <ActivityIndicator size={25} color={"#000000"} />
      </View>
    );
  };

  renderReadMainStoryBanner = (darkMode) => {
    return (
      <View style={{ backgroundColor: "#ffffff", marginTop: 30 }}>
        <View
          style={[
            helpers.isDesktop() ? Flex.row : Flex.column,
            Flex.alignStart,
            Flex.justfiyCenter,
            Flex.FlexWrap,
            {
              maxWidth: helpers.isDesktop() ? "90%" : "100%",
              width: "100%",
              margin: "auto",
              marginTop: 0,
              marginBottom: 0,
            },
          ]}
        >
          <View
            style={[
              helpers.isDesktop() ? Flex.row : Flex.flexColumnReverse,
              Flex.alignStart,
              Flex.justfiyCenter,
              {
                maxWidth: helpers.isDesktop() ? "100%" : "100%",
                width: "100%",
                margin: "auto",
                padding: 20,
                paddingBottom: 0,
              },
            ]}
          >
            <View style={{ width: helpers.isDesktop() ? "70%" : "100%" }}>
              <Text
                style={[
                  {
                    fontSize: helpers.isDesktop() ? 42 : 24,
                    lineHeight: helpers.isDesktop() ? 50.4 : 31,
                    fontFamily: FontFamily.abrilFatface,
                    color: "#051462",
                    paddingBottom: 15,
                    textAlign: "left",
                  },
                  darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                ]}
              >
                Read main story of that day
              </Text>
            </View>

            <View
              style={[
                Flex.row,
                helpers.isDesktop() ? Flex.justifyEnd : Flex.justifyStart,
                { width: "30%" },
              ]}
            >
              <View
                style={{
                  width: helpers.isDesktop() ? 167 : 100,
                  marginBottom: 10,
                }}
              >
                <CustomImage
                  source={logo}
                  require={true}
                  style={[
                    helpers.isWeb()
                      ? {
                        width: helpers.isDesktop() ? 116 : 96,
                        height: "auto",
                      }
                      : { width: helpers.isDesktop() ? 116 : 96, height: 30 },
                  ]}
                  altText={"The Morning Context"}
                />
              </View>
            </View>
          </View>

          <View
            style={[
              helpers.isDesktop() ? Flex.row : Flex.column,
              Flex.alignStart,
              {
                maxWidth: helpers.isDesktop() ? "90%" : "100%",
                width: helpers.isDesktop() ? "90%" : "100%",
                margin: "auto",
                marginTop: helpers.isDesktop() ? 30 : 10,
                marginBottom: 0,
              },
            ]}
          >
            <View
              style={{
                padding: 20,
                width: helpers.isDesktop() ? "90%" : "100%",
                paddingTop: 0,
              }}
            >
              <Text
                style={[
                  {
                    fontSize: helpers.isDesktop() ? 19 : 16,
                    lineHeight: helpers.isDesktop() ? 22.8 : 19.5,
                    fontFamily: FontFamily.medium,
                    color: "#F7A34B",
                    textTransform: "uppercase",
                  },
                  { paddingBottom: 3, textAlign: "left" },
                  darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                ]}
              >
                internet
              </Text>
              <Text
                style={[
                  {
                    fontSize: helpers.isDesktop() ? 30 : 22,
                    lineHeight: helpers.isDesktop() ? 45 : 32.56,
                    fontFamily: FontFamily.medium,
                    color: "#000000",
                  },
                  { paddingBottom: 3, textAlign: "left" },
                  darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                ]}
              >
                How India is handling human to animal transmission of COVID-19
                (or not)
              </Text>
              <ImageBackground
                style={[
                  {
                    width: "100%",
                    height: helpers.isDesktop() ? 168 : 114,
                    margin: "auto",
                    background: "#ccc",
                  },
                ]}
                source={archiveIStoryName}
                resizeMode="cover"
              ></ImageBackground>
              <Text
                style={[
                  {
                    fontSize: helpers.isDesktop() ? 30 : 27,
                    lineHeight: helpers.isDesktop() ? 45 : 35,
                    fontFamily: FontFamily.medium,
                    color: "#000000",
                  },
                  { paddingBottom: 3, marginTop: 10, textAlign: "left" },
                  darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                ]}
              ></Text>
              <HTML
                html={this.state.locked_content}
                tagsStyles={postExcerptTags}
                classesStyles={postExcerptClasses}
                onLinkPress={(event, href, data) => this.props.openLink(href)}
              />
            </View>
          </View>
          <View
            style={[
              Flex.row,
              Flex.alignStart,
              Flex.justfiyCenter,
              { width: "100%" },
            ]}
          >
            <View
              style={[
                { padding: 20, width: helpers.isDesktop() ? 200 : "80%" },
              ]}
            >
              <ButtonGradient
                title={"LEARN MORE"}
                rootStyle={{
                  btnWrapper: [
                    button.primaryGradient,
                    { width: "100%", height: helpers.isDesktop() ? 60 : 40 },
                  ],
                  btnText: [
                    button.primaryGradientText,
                    { fontSize: 16, fontWeight: "400" },
                  ],
                }}
                onClick={() => null}
                darkMode={darkMode}
              />
            </View>
          </View>
        </View>
      </View>
    );
  };
  renderReadStoryFreeBanner = (darkMode) => {
    return (
      <View
        style={
          helpers.isWeb()
            ? {
              position: "absolute",
              width: "100%",
              height: "20%",
              bottom: 0,
              left: 0,
              right: 0,
            }
            : {
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 20,
              right: 0,
            }
        }
      >
        <View
          style={{
            shadowColor: "#ffffff",
            shadowOffset: { width: 0, height: -22 },
            shadowOpacity: 1,
            shadowRadius: 200,
            elevation: 5,
            position: "absolute",
            width: "100%",
            height: helpers.isDesktop() ? 280 : 300,
            bottom: 0,
            left: 0,
            textAlign: "center",
            backgroundColor: "#ffffff",
            padding: 20,
            paddingBottom: 50,
            paddingLeft: 20,
            paddingTop: 40,
            paddingBottom: 20,
          }}
        >
          <Text
            style={[
              {
                fontSize: helpers.isDesktop() ? 42 : 24,
                lineHeight: helpers.isDesktop() ? 50 : 32,
                paddingBottom: helpers.isDesktop() ? 16 : 16,
                fontFamily: FontFamily.abrilFatface,
                color: "#051462",
              },
              { textAlign: "center" },
              darkMode && { color: "rgba(255, 255, 255, 0.89)" },
            ]}
          >
            Read the edition for free
          </Text>

          <Text
            style={[
              {
                fontSize: helpers.isDesktop() ? 24 : 16,
                lineHeight: helpers.isDesktop() ? 36 : 23.68,
                paddingBottom: helpers.isDesktop() ? 20 : 20,
                fontFamily: FontFamily.regular,
                color: "#051462",
              },
              { textAlign: "center" },
              darkMode && { color: "rgba(255, 255, 255, 0.89)" },
            ]}
          >
            Sign up for Yesterday and let it help you catch up with the news. We
            land in your inbox every weekday at 8 am IST.
          </Text>
          <View style={[Flex.row, Flex.alignStart, Flex.justfiyCenter]}>
            <View
              style={{ padding: 20, width: helpers.isDesktop() ? 200 : "100%" }}
            >
              <ButtonGradient
                title={"Sign up"}
                rootStyle={{
                  btnWrapper: [
                    button.primaryGradient,
                    { width: "100%", height: helpers.isDesktop() ? 60 : 40 },
                  ],
                  btnText: [
                    button.primaryGradientText,
                    { fontSize: 16, fontWeight: "400" },
                  ],
                }}
                onClick={() =>
                  this.props.navigateToScreen(
                    `/sign-up?redirect=${this.props.history?.location?.pathname}`
                  )
                }
                darkMode={darkMode}
              />
            </View>
          </View>
        </View>
      </View>
    );
  };
  renderPageContent = () => {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let { isUserLoggedIn, isArchiveStory, storyData, seletedTab } = this.state;
    let path = window.location.origin + window.location.pathname;
    // let path = "https://themorningcontext.com" + window.location.pathname;
    return (
      <>
        {storyData ? (
          <View>
            {/* </View><View style={[{ backgroundColor: "#F3F5FF", position: "relative", height: helpers.isDesktop() ? 1150 : 780, overflow: "hidden" }, { padding: helpers.isDesktop() ? 40 : 20, paddingTop: helpers.isDesktop() ? 0 : 20, paddingBottom: helpers.isDesktop() ? 0 : 20 }, darkMode && { backgroundColor: Colors.darkPurple }]}> */}

            <View
              style={[
                {
                  backgroundColor: "#F3F5FF",
                  position: "relative",
                  height: helpers.isDesktop()
                    ? isUserLoggedIn
                      ? "auto"
                      : 1480
                    : isUserLoggedIn
                      ? "auto"
                      : 1050,
                  overflow: isUserLoggedIn ? "visible" : "hidden",
                },
                {
                  paddingLeft: helpers.isDesktop() ? 40 : 20,
                  paddingRight: helpers.isDesktop() ? 40 : 20,
                  paddingTop: helpers.isDesktop() ? 0 : 20,
                  paddingBottom: 20,
                  marginBottom: helpers.isDesktop() ? "auto" : -23,
                },
                darkMode && { backgroundColor: Colors.darkPurple },
              ]}
            >
              <View
                style={[
                  helpers.isDesktop() ? Flex.row : Flex.column,
                  Flex.alignCenter,
                  Flex.justfiyCenter,
                  {
                    maxWidth: helpers.isDesktop() ? "90%" : "100%",
                    width: "100%",
                    margin: "auto",
                    marginTop: 0,
                    marginBottom: 0,
                  },
                ]}
              >
                {/* <View
                  style={[
                    {
                      width: helpers.isDesktop() ? "20%" : "100%",
                      padding: 10,
                    },
                  ]}
                ></View> */}
                <View style={[{ width: helpers.isDesktop() ? "70%" : "100%" }]}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={() => this.navigateScreen("breadcrumb")}
                    >
                      <Text
                        style={[
                          {
                            fontSize: helpers.isDesktop() ? 18 : 16,
                            lineHeight: helpers.isDesktop() ? 21 : 23.5,
                            fontFamily: FontFamily.regular,
                            color: "#051462",
                          },
                          {
                            textAlign: "left",
                            marginTop: helpers.isDesktop() ? 34 : 10,
                            marginBottom: helpers.isDesktop() ? 15 : 10,
                          },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        Yesterday{" "}
                      </Text>
                    </TouchableOpacity>
                    <Text
                      style={[
                        {
                          fontSize: helpers.isDesktop() ? 18 : 16,
                          lineHeight: helpers.isDesktop() ? 21 : 23.5,
                          fontFamily: FontFamily.regular,
                          color: "#051462",
                        },
                        {
                          textAlign: "left",
                          marginTop: helpers.isDesktop() ? 34 : 10,
                          marginBottom: helpers.isDesktop() ? 15 : 10,
                        },
                        darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                      ]}
                    >
                      &gt;{" "}
                      {moment(storyData?.published_date).format(
                        "DD MMMM, YYYY"
                      )}
                    </Text>
                  </View>

                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 48 : 24,
                        lineHeight: helpers.isDesktop() ? 64.75 : 32,
                        fontFamily: FontFamily.abrilFatface,
                        color: "#051462",
                      },
                      { paddingBottom: 3, textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    {ReactHtmlParser(storyData?.title)}
                  </Text>
                  <View
                    style={[
                      Flex.alignStar,
                      {
                        marginBottom: 20,
                        flexDirection: helpers.isDesktop() ? "row" : "column",
                      },
                    ]}
                  >
                    <View
                      style={[
                        Flex.alignStart,

                        Flex.row,
                        {
                          // flexDirection: helpers.isDesktop() ? "row" : "column",
                          padding: 10,
                          paddingLeft: 0,
                          paddingRight: 20,
                        },
                      ]}
                    >
                      {storyData && storyData.authors && (
                        <>
                          <View
                            style={[
                              Flex.alignCenter,
                              Flex.justfiyCenter,
                              Flex.row,
                              {
                                width: 40,
                                height: 40,
                                borderWidth: 1,
                                borderColor: "rgb(252, 135, 109)",
                                borderRadius: 40,
                                marginRight: 10,
                                borderStyle: "solid",
                                marginTop: "-10px",
                              },
                            ]}
                          >
                            <TouchableOpacity
                              onPress={() => {
                                window.open(
                                  `/writers/${storyData.authors[0].slug}`,
                                  "_self"
                                );
                              }}
                            >
                              <View
                                style={{
                                  width: 34,
                                  height: 34,
                                  overflow: "hidden",
                                  borderRadius: 36,
                                }}
                              >
                                <CustomImage
                                  resizeMode={"contain"}
                                  source={storyData.authors[0].image}
                                  require={true}
                                  style={[
                                    {
                                      height: 34,
                                      width: 34,
                                      borderRadius: 20,
                                    },
                                  ]}
                                  altText={storyData.authors[0].name}
                                />
                              </View>
                            </TouchableOpacity>
                          </View>
                          <TouchableOpacity
                            onPress={() => {
                              window.open(
                                `/writers/${storyData.authors[0].slug}`,
                                "_self"
                              );
                            }}
                          >
                            <View style={{ marginRight: 10 }}>
                              <Text
                                style={[
                                  {
                                    fontSize: helpers.isDesktop() ? 16 : 15,
                                    lineHeight: helpers.isDesktop() ? 19.2 : 18,
                                    fontFamily: FontFamily.regular,
                                    color: "#000000",
                                  },
                                  { textAlign: "left", marginBottom: 0 },
                                  darkMode && {
                                    color: "rgba(255, 255, 255, 0.89)",
                                  },
                                ]}
                              >
                                {storyData.authors[0].name}{" "}
                                {/* {helpers.isDesktop() ? null : "\n"} */}
                              </Text>
                            </View>
                          </TouchableOpacity>
                        </>
                      )}
                      {storyData &&
                        storyData.authors &&
                        storyData.authors.length > 1 &&
                        !this.state.seeSecondAuthor && (
                          <TouchableOpacity
                            onPress={() =>
                              this.setState({ seeSecondAuthor: true })
                            }
                          >
                            {helpers.isWeb() ? (
                              <View
                                style={[
                                  {
                                    borderStyle: "solid",
                                    fontFamily: FontFamily.regular,
                                    fontSize: helpers.isDesktop() ? 16 : 16,
                                    lineHeight: helpers.isDesktop() ? 19 : 22,
                                    borderWidth: 1,
                                    backgroundColor: "#F3F5FF",
                                    borderColor: "#907CFF",
                                    width: 28,
                                    height: 28,
                                    borderRadius: 28,
                                    marginRight: 5,
                                    marginTop: "-4px",
                                  },
                                  Flex.alignCenter,
                                  Flex.row,
                                  Flex.justfiyCenter,
                                ]}
                              >
                                {`+${storyData.authors.length - 1}`}
                              </View>
                            ) : (
                              <Text
                                style={[
                                  {
                                    borderStyle: "solid",
                                    fontFamily: FontFamily.regular,
                                    fontSize: helpers.isDesktop() ? 16 : 16,
                                    lineHeight: helpers.isDesktop() ? 19 : 22,
                                    borderWidth: 1,
                                    backgroundColor: "#F3F5FF",
                                    borderColor: "#907CFF",
                                    width: 28,
                                    height: 28,
                                    borderRadius: 28,
                                    marginRight: 5,
                                    marginTop: "-4px",
                                  },
                                  Flex.alignCenter,
                                  Flex.row,
                                  Flex.justfiyCenter,
                                ]}
                              >
                                {`+${storyData.authors.length - 1}`}
                              </Text>
                            )}
                          </TouchableOpacity>
                        )}
                    </View>

                    <View
                      style={[
                        Flex.alignStart,
                        Flex.row,
                        {
                          paddingTop: 10,
                          paddingLeft: 0,
                          paddingRight: 20,
                          paddingBottom: 10,
                          width: helpers.isDesktop() ? "46%" : "100%",
                        },
                      ]}
                    >
                      {storyData &&
                        storyData.authors &&
                        this.state.seeSecondAuthor &&
                        storyData?.authors.map((item, idx) => {
                          if (idx >= 1) {
                            return (
                              <View
                                style={{
                                  flexDirection: "row",
                                  flexBasis: "50%",
                                  flex: 1,
                                  flexWrap: "wrap",
                                }}
                              >
                                <View
                                  style={[
                                    Flex.alignCenter,
                                    Flex.justfiyCenter,
                                    // Flex.row,
                                    {
                                      width: 40,
                                      height: 40,
                                      borderWidth: 1,
                                      borderColor: "rgb(252, 135, 109)",
                                      borderRadius: 40,
                                      marginRight: 10,
                                      borderStyle: "solid",
                                      marginTop: "-10px",
                                    },
                                  ]}
                                >
                                  <TouchableOpacity
                                    onPress={() => {
                                      window.open(
                                        `/writers/${item.slug}`,
                                        "_self"
                                      );
                                    }}
                                  >
                                    <View
                                      style={{
                                        width: 34,
                                        height: 34,
                                        overflow: "hidden",
                                        borderRadius: 36,
                                      }}
                                    >
                                      <CustomImage
                                        resizeMode={"contain"}
                                        source={item.image}
                                        require={true}
                                        style={[
                                          {
                                            height: 34,
                                            width: 34,
                                            borderRadius: 20,
                                          },
                                        ]}
                                        altText={item.name}
                                      />
                                    </View>
                                  </TouchableOpacity>
                                </View>

                                <TouchableOpacity
                                  onPress={() => {
                                    window.open(
                                      `/writers/${item.slug}`,
                                      "_self"
                                    );
                                  }}
                                >
                                  <View style={{ marginRight: 10 }}>
                                    <Text
                                      style={[
                                        {
                                          fontSize: helpers.isDesktop()
                                            ? 16
                                            : 15,
                                          lineHeight: helpers.isDesktop()
                                            ? 19.2
                                            : 18,
                                          fontFamily: FontFamily.regular,
                                          color: "#000000",
                                        },
                                        {
                                          textAlign: "left",
                                          marginBottom: 0,
                                        },
                                        darkMode && {
                                          color: "rgba(255, 255, 255, 0.89)",
                                        },
                                      ]}
                                    >
                                      {item.name}{" "}
                                    </Text>
                                  </View>
                                </TouchableOpacity>
                              </View>
                            );
                          }
                        })}
                    </View>
                    {/* </View> */}
                    {/* <View style={[Flex.row, Flex.alignStart, { padding: 10, paddingLeft: 0, paddingRight: 10 }]}>
                                    <View style={[Flex.alignCenter, Flex.justfiyCenter, Flex.row, { width: 24, height: 24, borderWidth: 1, borderColor: "#EF3C3B", borderRadius: 24, marginRight: helpers.isDesktop() ? 15 : 10, }]}>
                                        <View style={{ width: 22.4, height: 22.4, borderWidth: 2, borderColor: "#ffffff", borderRadius: 24, overflow: "hidden" }}>
                                            <CustomImage
                                                resizeMode={'contain'}
                                                source={profile}
                                                require={true}
                                                style={[{ width: "100%", borderRadius: 24, height: "100%" }]}
                                                altText={'Have Only 5 Minutes'}
                                            />
                                        </View>

                                    </View>
                                    <View>
                                        <Text style={[{ fontSize: helpers.isDesktop() ? 16 : 15, lineHeight: helpers.isDesktop() ? 19.2 : 18, fontFamily: FontFamily.regular, color: '#000000' }, { textAlign: "left", marginBottom: 0 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                            Gaurangi Agarwal
                                        </Text>
                                        <Text style={[{ fontSize: helpers.isDesktop() ? 16 : 15, lineHeight: helpers.isDesktop() ? 19.2 : 18, fontFamily: FontFamily.light, color: '#000000' }, { textAlign: "left", marginBottom: helpers.isDesktop() ? 15 : 10 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                            Mumbai
                                        </Text>
                                    </View>
                                </View> */}
                  </View>
                </View>
              </View>
              <View
                style={[
                  helpers.isDesktop() ? Flex.row : Flex.column,
                  Flex.alignStart,
                  Flex.justfiyCenter,
                  {
                    maxWidth: helpers.isDesktop() ? "90%" : "100%",
                    width: "100%",
                    marginLeft: helpers.isDesktop() ? "-48px" : 0,
                    // margin: "auto",
                    // marginTop: 0,
                    // marginBottom: helpers.isDesktop() ? 60 : 20,
                  },
                ]}
              >
                <View
                  style={[
                    !helpers.isDesktop() && {
                      height: "auto",
                    },
                    {
                      width: helpers.isDesktop() ? "70%" : "100%",
                      marginLeft: helpers.isDesktop() ? "20%" : 0,
                    },
                  ]}
                >
                  {storyData && storyData?.featured_image && (
                    <CustomImage
                      source={storyData.featured_image}
                      require={true}
                      resizeMode={"cover"}
                      style={{
                        width: "100%",
                        height: "auto",
                        backgroundColor: "red",
                      }}
                      webStyle={{
                        width: "100%",
                        height: "auto",
                        backgroundColor: "red",
                      }}
                      altText={"The Morning Context"}
                    />
                  )}
                </View>
              </View>

              <View
                style={[
                  helpers.isDesktop() ? Flex.row : Flex.column,
                  Flex.alignStart,
                  Flex.justfiyCenter,
                  {
                    maxWidth: helpers.isDesktop() ? "90%" : "100%",
                    width: "100%",
                    marginLeft: helpers.isDesktop() ? "-48px" : 0,
                    // margin: "auto",
                    // marginTop: 0,
                    // marginBottom: helpers.isDesktop() ? 60 : 20,
                  },
                ]}
              >
                {helpers.isDesktop() && (
                  <View
                    style={[
                      {
                        width: helpers.isDesktop() ? "20%" : "100%",
                        paddingTop: 10,
                        position: 'sticky',
                        top: 50
                      },
                    ]}
                  >
                    {storyData &&
                      storyData.posts &&
                      storyData.posts.map((item, index) => {
                        return (
                          <>
                            {/* 6C7AF6 */}
                            <TouchableOpacity
                              onPress={() => {
                                this.setState({ seletedTab: index });
                                //   window.scroll(0, index * 943);
                                this.scrollToElement(index);
                              }}
                              style={[
                                {
                                  marginBottom: 15,
                                  color: "#051462",
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                },
                                {
                                  fontSize: helpers.isDesktop() ? 14 : 16,
                                  lineHeight: helpers.isDesktop() ? 20 : 23,
                                  fontFamily: FontFamily.regular,
                                },
                                { textAlign: "left", marginBottom: 15 },
                                darkMode && {
                                  color: "rgba(255, 255, 255, 0.89)",
                                },
                                seletedTab == index && {
                                  borderLeftWidth: 2,
                                  fontFamily: FontFamily.bold,
                                  borderColor: "#6C7AF6",
                                  color: "#907CFF",
                                },
                              ]}
                            >
                              {item.title}
                            </TouchableOpacity>
                            {/* <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Government curbs export of COVID-19 Rapid Antigen Testing kits
                            </TouchableOpacity>
                            <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Quick updates on what unfolded in Afghanistan
                            </TouchableOpacity>
                            <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Live-in relationship between man and married woman illegal: Rajasthan HC
                            </TouchableOpacity>
                            <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                TCS became the second Indian firm to cross ₹13 lakh crore in market value
                            </TouchableOpacity> */}
                          </>
                        );
                      })}
                    <View
                      style={{
                        width: "100%",
                        height: 2,
                        backgroundColor: "#DCD5FF",
                        marginTop: 10,
                        marginBottom: 10,
                      }}
                    ></View>
                    <Text
                      style={[
                        {
                          fontSize: helpers.isDesktop() ? 16 : 16,
                          lineHeight: helpers.isDesktop() ? 19.2 : 23.5,
                          fontFamily: FontFamily.regular,
                          color: "#000000",
                        },
                        {
                          textAlign: helpers.isDesktop() ? "left" : "center",
                          marginBottom: helpers.isDesktop() ? 10 : 10,
                        },
                        darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                      ]}
                    >
                      Share
                    </Text>
                    <View style={[Flex.row]}>
                      <TouchableOpacity
                        onPress={() => {
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=${path}&quote=${ReactHtmlParser(
                              storyData.title
                            )}`,
                            "_blank"
                          );
                        }}
                        style={[
                          {
                            marginBottom: 15,
                            paddingLeft: 0,
                            paddingRight: 10,
                          },
                          {
                            fontSize: helpers.isDesktop() ? 14 : 16,
                            lineHeight: helpers.isDesktop() ? 20 : 23,
                            fontFamily: FontFamily.bold,
                            color: "#907CFF",
                          },
                          { textAlign: "left" },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        <CustomImage
                          source={facebook16}
                          require={true}
                          style={{ width: 16, height: 16 }}
                          webStyle={{ width: 16, height: 16 }}
                          altText={"The Morning Context"}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          window.open(
                            // `https://twitter.com/intent/tweet?text=${storyData.title}&url=${path}`,
                            `https://twitter.com/intent/tweet?text=${ReactHtmlParser(
                              storyData.title
                            )}&url=${path}`,

                            "_blank"
                          );
                        }}
                        style={[
                          {
                            marginBottom: 15,
                            paddingLeft: 0,
                            paddingRight: 10,
                          },
                          {
                            fontSize: helpers.isDesktop() ? 14 : 16,
                            lineHeight: helpers.isDesktop() ? 20 : 23,
                            fontFamily: FontFamily.bold,
                            color: "#907CFF",
                          },
                          { textAlign: "left" },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        <CustomImage
                          source={twitter16}
                          require={true}
                          style={{ width: 16, height: 16 }}
                          webStyle={{ width: 16, height: 16 }}
                          altText={"The Morning Context"}
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          window.open(
                            `https://www.linkedin.com/shareArticle?mini=true&url=${path}&summary=${ReactHtmlParser(
                              storyData.title
                            )}`,
                            "_blank"
                          );
                        }}
                        style={[
                          {
                            marginBottom: 15,
                            paddingLeft: 0,
                            paddingRight: 10,
                          },
                          {
                            fontSize: helpers.isDesktop() ? 14 : 16,
                            lineHeight: helpers.isDesktop() ? 20 : 23,
                            fontFamily: FontFamily.bold,
                            color: "#907CFF",
                          },
                          { textAlign: "left" },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        <CustomImage
                          source={linkedin16}
                          require={true}
                          style={{ width: 16, height: 16 }}
                          webStyle={{ width: 16, height: 16 }}
                          altText={"The Morning Context"}
                        />
                      </TouchableOpacity>
                      {/* <Tooltip popover={<Text>Info here</Text>}> */}
                      <Popable
                        content="Copied"
                        onAction={(visible) => {
                          if (visible) {
                            this.copyToClipboard();
                          }
                        }}
                      >
                        <CustomImage
                          source={link16}
                          require={true}
                          style={{ width: 16, height: 16 }}
                          webStyle={{ width: 16, height: 16 }}
                          altText={"The Morning Context"}
                        />
                      </Popable>
                    </View>
                  </View>
                )}

                <View style={[{ width: helpers.isDesktop() ? "70%" : "100%" }]}>
                  {storyData &&
                    storyData.posts &&
                    storyData.posts.map((item, index) => {
                      // console.log("itemitem:", item);
                      return (
                        <View
                          ref={(ref) => this._nodes.set(index, ref)}
                          style={[
                            helpers.isDesktop() && {
                              backgroundColor: "#F3F5FF",
                            },
                            {
                              padding: helpers.isDesktop() ? 0 : 0,
                              paddingBottom: 0,
                              marginBottom: !isUserLoggedIn ? 20 : 20,
                            },
                            darkMode && { backgroundColor: Colors.darkPurple },
                          ]}
                        >
                          <View
                            style={[
                              helpers.isDesktop() && {
                                backgroundColor: "#ffffff",
                              },
                              {
                                padding: helpers.isDesktop() ? 20 : 0,
                                width: "100%",
                                margin: "auto",
                              },
                            ]}
                          >
                            <View
                              style={[
                                { backgroundColor: "#ffffff" },
                                { padding: helpers.isDesktop() ? 20 : 16 },
                                darkMode && {
                                  backgroundColor: Colors.darkPurple,
                                },
                              ]}
                            >
                              <View
                                style={[
                                  {
                                    width: helpers.isDesktop()
                                      ? "100%"
                                      : "100%",
                                    marginBottom: 15,
                                  },
                                ]}
                              >
                                {item.category.map((value, index) => {
                                  return (
                                    <View>
                                      <Text
                                        style={[
                                          {
                                            color: renderBorderColor(value),
                                            fontFamily: FontFamily.bold,
                                            textTransform: "uppercase",
                                            fontSize: 15,
                                            lineHeight: 16,
                                            backgroundImage: `url(${categoryImage(
                                              value
                                            )})`,
                                            backgroundRepeat: "no-repeat",
                                          },
                                          paddingCategory(value),
                                        ]}
                                      >
                                        {value}
                                      </Text>
                                    </View>
                                    // <View>
                                    //   <Text
                                    //     style={{
                                    //       color: renderBorderColor(value),
                                    //       fontFamily: FontFamily.bold,
                                    //       textTransform: "uppercase",
                                    //       fontSize: 20,
                                    //     }}
                                    //   >
                                    //     {value}
                                    //   </Text>
                                    // </View>
                                    // <CustomImage
                                    //   source={categoryImage(value)}
                                    //   // source={healthcare}
                                    //   require={true}
                                    //   style={[
                                    //     helpers.isWeb()
                                    //       ? {
                                    //         width: helpers.isDesktop()
                                    //           ? 116
                                    //           : 96,
                                    //         height: "auto",
                                    //       }
                                    //       : {
                                    //         width: helpers.isDesktop()
                                    //           ? 116
                                    //           : 96,
                                    //         height: 30,
                                    //       },
                                    //   ]}
                                    //   altText={"The Morning Context"}
                                    // />
                                  );
                                })}
                              </View>

                              <View key={index}>
                                <Text
                                  style={[
                                    {
                                      fontSize: helpers.isDesktop() ? 36 : 22,
                                      lineHeight: helpers.isDesktop() ? 40 : 32,
                                      fontFamily: FontFamily.bold,
                                      color: "#051462",
                                      marginBottom: -2,
                                    },
                                    { textAlign: "left" },
                                    darkMode && {
                                      color: "rgba(255, 255, 255, 0.89)",
                                    },
                                  ]}
                                >
                                  {item.title}
                                </Text>
                                {/* <CustomImage
                                                            source={item.featured_image}
                                                            require={true}
                                                            resizeMode={'cover'}
                                                            style={{ width: "100%", height: 200, backgroundColor: "red" }}
                                                            altText={'The Morning Context'}
                                                        /> */}

                                <Text
                                  style={[
                                    {
                                      fontSize: helpers.isDesktop() ? 18 : 16,
                                      lineHeight: helpers.isDesktop() ? 26 : 23,
                                      fontFamily: FontFamily.regular,
                                      color: "#051462",
                                      marginTop: 0,
                                    },
                                    { paddingBottom: 3, textAlign: "left" },
                                    darkMode && {
                                      color: "rgba(255, 255, 255, 0.89)",
                                    },
                                  ]}
                                >
                                  <PostContent
                                    data={item.content}
                                    darkMode={darkMode}
                                    openLink={(link) =>
                                      this.openSocialMedia(link)
                                    }
                                  />
                                </Text>
                              </View>
                              <Text
                                style={[
                                  {
                                    fontSize: helpers.isDesktop() ? 16 : 16,
                                    lineHeight: helpers.isDesktop()
                                      ? 19.2
                                      : 23.5,
                                    fontFamily: FontFamily.regular,
                                    color: "#000000",
                                  },
                                  {
                                    textAlign: helpers.isDesktop()
                                      ? "left"
                                      : "left",
                                    marginBottom: helpers.isDesktop() ? 10 : 10,
                                  },
                                  darkMode && {
                                    color: "rgba(255, 255, 255, 0.89)",
                                  },
                                ]}
                              >
                                Share
                              </Text>
                              <View style={[Flex.row]}>
                                <TouchableOpacity
                                  onPress={() => {
                                    window.open(
                                      `https://www.facebook.com/sharer/sharer.php?u=${path}?post_id=${index}&quote=${ReactHtmlParser(item.title)}`,
                                      "_blank"
                                    );
                                  }}
                                  style={[
                                    {
                                      marginBottom: 15,
                                      paddingLeft: 0,
                                      paddingRight: 10,
                                    },
                                    {
                                      fontSize: helpers.isDesktop() ? 14 : 16,
                                      lineHeight: helpers.isDesktop() ? 20 : 23,
                                      fontFamily: FontFamily.bold,
                                      color: "#907CFF",
                                    },
                                    { textAlign: "left" },
                                    darkMode && {
                                      color: "rgba(255, 255, 255, 0.89)",
                                    },
                                  ]}
                                >
                                  <CustomImage
                                    source={facebook16}
                                    require={true}
                                    style={{ width: 16, height: 16 }}
                                    webStyle={{ width: 16, height: 16 }}
                                    altText={"The Morning Context"}
                                  />
                                </TouchableOpacity>
                                <TouchableOpacity
                                  onPress={() => {
                                    window.open(
                                      // `https://twitter.com/intent/tweet?text=${item.title}&url=${path}`,
                                      `https://twitter.com/intent/tweet?text=${ReactHtmlParser(
                                        item.title
                                      )}&url=${path}?post_id=${index}`,

                                      "_blank"
                                    );
                                  }}
                                  style={[
                                    {
                                      marginBottom: 15,
                                      paddingLeft: 0,
                                      paddingRight: 10,
                                    },
                                    {
                                      fontSize: helpers.isDesktop() ? 14 : 16,
                                      lineHeight: helpers.isDesktop() ? 20 : 23,
                                      fontFamily: FontFamily.bold,
                                      color: "#907CFF",
                                    },
                                    { textAlign: "left" },
                                    darkMode && {
                                      color: "rgba(255, 255, 255, 0.89)",
                                    },
                                  ]}
                                >
                                  <CustomImage
                                    source={twitter16}
                                    require={true}
                                    style={{ width: 16, height: 16 }}
                                    webStyle={{ width: 16, height: 16 }}
                                    altText={"The Morning Context"}
                                  />
                                </TouchableOpacity>
                                <TouchableOpacity
                                  onPress={() => {
                                    // this.shareOnLinkedIn(path, index, item.title);
                                    window.open(
                                      `https://www.linkedin.com/shareArticle?mini=true&url=${path}#post_id=${index}&title=${ReactHtmlParser(item.title)}&summary=${ReactHtmlParser(item.title)}&source=Via%20TMC`,
                                      "_blank"
                                    );
                                  }}
                                  style={[
                                    {
                                      marginBottom: 15,
                                      paddingLeft: 0,
                                      paddingRight: 10,
                                    },
                                    {
                                      fontSize: helpers.isDesktop() ? 14 : 16,
                                      lineHeight: helpers.isDesktop() ? 20 : 23,
                                      fontFamily: FontFamily.bold,
                                      color: "#907CFF",
                                    },
                                    { textAlign: "left" },
                                    darkMode && {
                                      color: "rgba(255, 255, 255, 0.89)",
                                    },
                                  ]}
                                >
                                  <CustomImage
                                    source={linkedin16}
                                    require={true}
                                    style={{ width: 16, height: 16 }}
                                    webStyle={{ width: 16, height: 16 }}
                                    altText={"The Morning Context"}
                                  />
                                </TouchableOpacity>
                                <Popable
                                  content="Copied"
                                  onAction={(visible) => {
                                    if (visible) {
                                      this.copyToClipboard();
                                    }
                                  }}
                                >
                                  <CustomImage
                                    source={link16}
                                    require={true}
                                    style={{ width: 16, height: 16 }}
                                    webStyle={{ width: 16, height: 16 }}
                                    altText={"The Morning Context"}
                                  />
                                </Popable>
                              </View>
                            </View>
                          </View>
                        </View>
                      );
                    })}
                  <View
                    style={[
                      {
                        width: helpers.isDesktop() ? "34%" : "100%",
                        alignSelf: "flex-end",
                      },
                    ]}
                  >
                    <ButtonGradient
                      title={"READ YESTERDAY ARCHIVES"}
                      rootStyle={{
                        btnWrapper: [
                          button.primaryGradient,
                          {
                            width: "100%",
                            height: helpers.isDesktop() ? 60 : 40,
                          },
                        ],
                        btnText: [
                          button.primaryGradientText,
                          { fontSize: 16, fontWeight: "400" },
                        ],
                      }}
                      onClick={() => this.navigateScreen("button")}
                      darkMode={darkMode}
                    />
                  </View>

                  {/* {isUserLoggedIn && <View style={[helpers.isDesktop() && {
                                backgroundColor: "#F3F5FF"
                            }, { padding: helpers.isDesktop() ? 0 : 0, paddingBottom: 0, marginBottom: !isUserLoggedIn ? 20 : 0 }, darkMode && { backgroundColor: Colors.darkPurple },]}>
                                <View style={[helpers.isDesktop() && { backgroundColor: "#ffffff" }, { padding: helpers.isDesktop() ? 20 : 0, width: "100%", margin: "auto" }]}>
                                    <View style={[{ backgroundColor: "#ffffff" }, { padding: helpers.isDesktop() ? 20 : 10 }, darkMode && { backgroundColor: Colors.darkPurple }]}>
                                        <View style={[{ width: helpers.isDesktop() ? 116 : 96, marginBottom: 15 }]}>
                                            <CustomImage
                                                source={healthcare}
                                                require={true}
                                                style={[helpers.isWeb() ? { width: helpers.isDesktop() ? 116 : 96, height: "auto" } : { width: helpers.isDesktop() ? 116 : 96, height: 30 }]}
                                                altText={'The Morning Context'}
                                            />
                                        </View>
                                        <View  >
                                            <Text style={[{ fontSize: helpers.isDesktop() ? 36 : 18, lineHeight: helpers.isDesktop() ? 39 : 26, fontFamily: FontFamily.bold, marginBottom: 15, color: '#051462' }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>New Zealand announced strict lockdown over one COVID-19 case second</Text>
                                            <CustomImage
                                                source={storyNameThumbnial}
                                                require={true}
                                                resizeMode={'cover'}
                                                style={{ width: "100%", height: 200, }}
                                                altText={'The Morning Context'}
                                            />

                                            <Text style={[{ fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 36 : 23, fontFamily: FontFamily.regular, color: '#051462', marginTop: 10 }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>The 63-year-old woman was infected with the Delta Plus variant of the virus, succumbing to it on July 27, said Brihanmumbai Municipal Corporation (BMC) officials. The authorities came to know only on August 11 that she was infected with the variant after her genome sequencing report was received. The woman tested positive on July 21 and had several comorbidities, including diabetes, according to officials. She was fully vaccinated and didn’t have any travel history. Two of her close contacts have also tested positive for the Delta Plus variant...
                                                Maharashtra has reported three deaths due to the Delta Plus variant so far.
                                            </Text>

                                        </View>
                                    </View>

                                </View>
                            </View >} */}
                </View>
              </View>

              {!isUserLoggedIn && this.renderReadStoryFreeBanner(darkMode)}
            </View>

            {!isArchiveStory && isUserLoggedIn ? (
              <ScrollContainerView>
                <YesterdayDontStopReading
                  navigation={this.props.navigation}
                  navigateWeb={(slug) => this.props.navigateToScreen(slug)}
                  navigateApp={(slug, params) =>
                    this.props.navigation.navigate(slug, params)
                  }
                />
              </ScrollContainerView>
            ) : null}

            {isArchiveStory && isUserLoggedIn
              ? this.renderReadMainStoryBanner(darkMode)
              : null}
          </View>
        ) : (
          <View style={[styles.container]}>
            <ActivityIndicator size="large" style={styles.activityIndicator} />
          </View>
        )}
      </>
    );
  };

  renderWebPage = () => {
    return (
      <>
        {this.renderPageHeader()}
        {this.renderPageContent()}
      </>
    );
  };

  renderAppPage = () => {
    const { footerData, storyData } = this.state;
    return (
      <ScrollView onScroll={this.getScrollOffset} ref={(ref) => (this.appscrollview = ref)}>
        {this.renderPageHeader()}
        {this.renderPageContent()}
        {storyData ? (
          <AppFooter
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            footerData={footerData}
          />
        ) : (
          <View style={[styles.container]}>
            <ActivityIndicator size="large" style={styles.activityIndicator} />
          </View>
        )}
      </ScrollView>
    );
  };

  getSeoObject = () => {
    let { storyData } = this.state;
    if (storyData) {
      return seoObj.getYesterdayEditionSeo(storyData);
    }
    return {};
  };

  render() {
    const { pageLoader, showErrorModal, footerData, storyData, hideSideShareActionButton } = this.state;
    const webView = helpers.isWeb();
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let redirectSlugs = {
      web: "/",
      native: { redirect: "/", verifyRedirect: "/" },
    };

    let storyActions = {
      bookmark: false,
      like: false
    };

    return (
      <>
        <View
          ref={this.applyRef}
          style={[
            webView && { paddingTop: helpers.isDesktop() ? 54 : 56 },
            appStyles.appBg,
            Flex.fill,
            darkMode && { backgroundColor: Colors.darkBlackColorBg },
          ]}
        >
          {/* header : we will be new component for this module */}
          <Seo
            data={this.getSeoObject()}
            page="/yesterday/:slug"
            pageData={storyData}
            url={
              process.browser
                ? window.location.origin + window.location.pathname
                : ""
            }
          />

          <AppHeader
            ref="header"
            history={this.props.history}
            searchQuery={this.props.searchQuery}
            locationHash={this.props.locationHash}
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            redirectSlugs={redirectSlugs}
            refreshPage={() =>
              this.setState({ subscriptionRefreshKey: !subscriptionRefreshKey })
            }
            setCredits={(credits) => this.setState({ credits: credits })}
            navigateToSubscriptionScreen
            darkMode={darkMode}
            showFullHeader={true}
          />
          {/* {postUnlocked && postData.story.content && ( */}


          {!showErrorModal && (
            <>
              {pageLoader
                ? this.showPageLoader()
                : webView
                  ? this.renderWebPage()
                  : this.renderAppPage()}
            </>
          )}
          {
            this.state.token && storyData?.title && (
              <View>
                <View
                  style={[
                    Padding.ph_2,
                    Helpers.conatinerWeb,
                    helpers.isDesktop() && Helpers.conatinerWeb1200,
                    { marginHorizontal: "auto" },
                  ]}
                >
                  {!hideSideShareActionButton &&

                    helpers.isWeb() && (
                      <PostShare
                        data={storyData}
                        postContent={true}
                        postTitle={storyData?.title}
                        storyActions={storyActions}
                        // applyStoryActions={(type, value, animateFunc) =>
                        //   this.applyStoryActions(type, value, true, () =>
                        //     animateFunc()
                        //   )
                        // }
                        sharePost={(slug) => this.sharePost(slug)}
                        shareTitle={storyData?.title}
                        bookmarkLoading={false}
                        // likeLoading={true}
                        darkMode={false}
                        giftStory={false}
                        allowShare={true}
                        fromPage={'yesterday'}
                      // credits={credits}
                      />
                    )}
                </View>
              </View>
            )
          }

          {storyData ? (
            <AppFooter
              navigateWeb={(slug) => this.props.navigateToScreen(slug)}
              navigateApp={(slug, params) =>
                this.props.navigation.navigate(slug, params)
              }
              footerData={footerData}
              Breadcrumbs={Breadcrumbs}
            />
          ) : null}

          {showErrorModal && (
            <ErrorModal
              goToHome={() => this.props.navigateToScreen("/")}
              tryAgain={() => this.getModalClickEvent()}
              show={showErrorModal}
            />
          )}
          {/* <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => this.scrollToTop()}
            style={customStyle.touchableOpacityStyle}
          >
            <FaArrowCircleUp style={customStyle.floatingButtonStyle} />
          </TouchableOpacity> */}
        </View>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { app, user } = state;
  return { app, user };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ removeUserToken }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationWrapper(YesterdayStoryScreen));

const customStyle = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: StatusBar.currentHeight,
  },
  scrollView: {},
  text: {
    fontSize: 42,
  },
  touchableOpacityStyle: {
    position: "absolute",
    width: 50,
    height: 50,
    alignItems: "center",
    justifyContent: "center",
    right: 30,
    bottom: 30,
  },
  floatingButtonStyle: {
    resizeMode: "contain",
    width: 50,
    height: 50,
    //backgroundColor:'black'
  },
});

let Breadcrumbs = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Yesterday",
  },
];
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
  },
  activityIndicator: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    height: 80,
  },
});
